import QueryProvider from "@/app/providers/query-provider";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import PromptInstall from "@/features/shared/components/pwa-add-to-home-screen/promptInstall";
import IosSplashScreen from "@/lib/ios-splash-screen";
import { bootstrapLocale } from "@/lib/locale-bootstrap";
import "@/styles/globals.css";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  redirect,
  Scripts
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { AuthContextProps } from "oidc-react";
import { Toaster } from "sonner";

export const Route = createRootRouteWithContext<{
  auth: AuthContextProps;
}>()({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/callback" || location.pathname.endsWith("/callback")) {
      return;
    }
    const result = bootstrapLocale(location.pathname);
    if (result.type === "redirect") {
      throw redirect({ href: result.to });
    }
  },
  component: RootComponent,
  notFoundComponent: () => <NotFoundPage />
});

function RootComponent() {
  return (
    <>
      <HeadContent />
      <Toaster richColors />
      <PromptInstall />
      <IosSplashScreen />
      <NuqsAdapter>
        <QueryProvider>
          <Outlet />
        </QueryProvider>
      </NuqsAdapter>
      {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-left" /> : null}
      <Scripts />
    </>
  );
}
